import styled from 'styled-components';
import { TextField as Field } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { colors } from '../../constants';
import { Button } from '../../constants/base';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${Button} {
    margin-top: 16px;
  }
`;

export const TextField = styled(Field)`
  width: 95%;
  margin: 8px 0 !important;
`;

export const ErrorText = styled.p`
  color: ${colors.red};
  text-align: center;
`;

export const Anchor = styled(Link)`
  color: ${colors.red};
  margin-top: 32px;
  text-align: center;
  display: block;
`;
